import { db, fb, auth,provider, storage } from '../../config/firebase';
import { clearUser, loginFailed, loginSuccess, logoutFxn, signupPending, signupFailed, storeUserData,storeCompanyData,storeProfileImages, isItLoading } from '../reducers/auth.slice';
import { v4 as uuidv4 } from 'uuid';
import { notifyErrorFxn, notifySuccessFxn } from 'src/utils/toast-fxn';
import { clearGroup } from '../reducers/group.slice';
import axios from 'axios';


  export const signin = (user, navigate,) => async (dispatch) => {
    dispatch(isItLoading(true))
   // setTimeout(()=>{dispatch(isItLoading(false))},2000)
    console.log("all is still well at this point-->")
    fb.auth().signInWithEmailAndPassword(user.email, user.password)
    .then((userCredential) => {
      // Signed in
     
      var user = userCredential.user;
      console.log('Signed In user is: ', user.email);
       dispatch(fetchUserData(user.uid, "sigin", navigate));
       setTimeout(()=>{dispatch(isItLoading(false))},2000)
    })
    .catch((error) => {
      console.log( ' PROBLEM REPORT ', error.message);
      dispatch(loginFailed(error.message));
      dispatch(isItLoading(false))
      var errorCode = error.code;
      var errorMessage = error.message;
      //notifyErrorFxn(errorMessage);
      
      console.log('Error Code is: ', errorCode, + ' Msg is: ', errorMessage);
     
    });

};


export const signInWithGoogle = (user, navigate,) => async (dispatch) => {

  fb.auth().signInWithPopup(provider)
  .then((userCredential)=>{

    
    var user = userCredential.user;
    console.log('Signed In user is: ', user.email);
    console.log('ALL THE DETAILS THAT COME BACK FROM THE GOOGLE SIGN IN ARE:',userCredential)
     dispatch(fetchUserData(user.uid, "sigin", navigate));

  }).catch((error) => {
    console.log( ' PROBLEM REPORT ', error.message);
    dispatch(loginFailed(error.message));
   
    var errorCode = error.code;
    var errorMessage = error.message;
    //notifyErrorFxn(errorMessage);
    
    console.log('Error Code is: ', errorCode, + ' Msg is: ', errorMessage);
   
  });

}


export const signup = (user,navigate) => async (dispatch) => {
  console.log(user);
   dispatch(signupPending());
   console.log("Just before the sign up happens!!!!")
    fb.auth().createUserWithEmailAndPassword(
      user.email,
      user.password
  ).then((res)=>{
     db.collection('users').doc(res.user.uid).set({
      uid: res.user.uid,
      firstName: user.fName,
      lastName:user.lName,
      email: user.email,
      phone: user.phone,
      password: user.password,
      registeredOn:new Date(),
      businessName:user.bName,
      lessonsWatched:[],
      purchasedCourses:[],
      savedCourses:[],
      companySize:user.companySize, 
      regType:user.regType, 
      country:user.country,
      certified:user.certified,
      state:user.state,
      industry:user.industry,
      city:user.city,
       profileImage:'src/assets/images/rec.png'
    })
    

    dispatch(fetchUserData(res.user.uid, "sigin"));
  }).then(() => {
   
    navigate("/dashboard/home");
  }).catch((err) => {
    console.error("Error signing up: ", err);
    var errorMessage = err.message;
    dispatch(signupFailed({ errorMessage }));
  })
}


export const createNewUser = (email,companyId,setIsLoading,setMessage) => async (dispatch) => {
 
   
   console.log("Just before the CREATING OF A NEW USER happens!!!!")
    fb.auth().createUserWithEmailAndPassword(
      email,
      '12345678'
  ).then(async(res)=>{
     db.collection('users').doc(res.user.uid).set({
      uid: res.user.uid,
      id: res.user.uid,
      
      name:`${email.split('@')[0]}`,
      email: email,
      companyID:companyId,
      photoUrl:"https://firebasestorage.googleapis.com/v0/b/bridgetech-advance-project.appspot.com/o/profile_images%2Fprofile.jpg?alt=media&token=b3c94ada-1b08-4834-bbd1-647882c7195a",
      contacts:[],
      queryMsg:[  
         {
          firstParagraph:"I hope you're doing well and navigating this season with clarity. It’s been about three months since we last connected, and I’ve been thinking about your role at Code Forge Labs—especially given how fast backend technologies and infrastructure tools are evolving. With performance optimization and scalable architecture top of mind for so many teams, your work is likely more impactful than ever.",
           secondParagraph:"While reading through some recent industry updates, I came across a couple of articles that I thought you might enjoy. They touch on themes related to backend efficiency, database design, and evolving best practices in engineering teams",
          thirdParagraph:"We had some great conversations previously, and I really appreciated hearing how you approach clean architecture and performance at scale. Let me know if you’re up for a quick catch-up sometime soon—I’d love to hear what you’ve been building (and maybe even what your latest keyboard mod looks like). Wishing you continued momentum",
          bulletPoints:[
            {
          bulletPointBold:"Deloitte Global's 2025 Airline CEO Survey",
          bulletPointRest:"Deloitte, May 30, 2025 Deloitte Link",
          id:"7",
          link:" "
            },
            {
              bulletPointBold:"A breath of fresh air for the national aviation industry",
              bulletPointRest:"PwC, June 3, 2025 PwC Link",
               id:"8",
               link:""
            }
          ]
         }
       ],
      lastActive:1759529429161,
      password: '12345678',
      registeredOn:new Date(),
      
    })


    const emailHTML = 
    ` <h2>Welcome to Nurturer!</h2>
         
           <br/>

           
           <p>Welcome aboard! Your registration on Nurturer is now complete, and you’re all set to begin using the platform.</p>
           <br/>


            <p>With Nurturer, you’ll have the tools to stay connected with your leads, nurture stronger relationships, and remain top of mind in a simple, effective way. Your access has already been set up, so you can dive right in and start making the most of the platform.</p>
            <br/>
            <p>We’re excited to have you join the Nurturer community and look forward to supporting your success.</p>
            <br/>

           

            <p>Warm Regards,</p>
            <p>The Nurturer Team</p>`
    


          const response = await axios.post(
           /*"http://localhost:5008/send-email",*/
       "https://nurturer-sendgrid-backend.vercel.app/send-email",
       /* "https://nurturer-sendgrid-backend-production.up.railway.app/send-email",*/
       {
        to: email && email, // or 'devs@nurturer.ai'
        subject: "Welcome to Nurturer",
        htmlMessage: emailHTML,
        name:email && email,
        userEmail:'info@nurturer.ai'
       },
       {
        headers: { 
          "Content-Type": "application/json",
        },
       }
       )
           

   //SET PASSWORD RESET EMAIL HERE - OCT 6 2025 - DAGOGO
   fb.auth().sendPasswordResetEmail(email)
  }).then(() => {
   
    setIsLoading(false)
    setMessage("User created successfully!")
  }).catch((err) => {
    console.error("Error creating new user: ", err);
    var errorMessage = err.message;
    setIsLoading(false)
    setMessage(err.message)
   // dispatch(signupFailed({ errorMessage }));
  })
}



export const uploadImage = (user, file, navigate, setLoading) => async (dispatch) => {
  const imageName = uuidv4() + '.' + file?.name?.split('.')?.pop();
  console.log('File Name: ', imageName);
  const uploadTask = storage.ref(`profile_images/${imageName}`).put(file);
  uploadTask.on(
    "state_changed",
    snapshot => {
      const progress = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      // setProgress(progress);
    },
    error => {
      console.log(error);
    },
    () => {
      storage
        .ref("profile_images")
        .child(imageName)
        .getDownloadURL()
        .then(url => {
          console.log('Image URL: ', url);
          dispatch(signup(user, file, navigate, setLoading, url));
        });
    }
  );
}


export const fetchUserData = (id, type, navigate) => async (dispatch) => {
  var user = db.collection("companies").doc(id);
  user.get().then((doc) => {
  if (doc.exists) {
    // console.log("User Data:", doc.data());
    dispatch(storeUserData(doc.data()));


    const companyRef = db
    .collection("companies")
    .where("companyID", "==", doc.data().companyID)
    .limit(1);
  
  companyRef.get().then((querySnapshot) => {
    if (!querySnapshot.empty) {
      const companyDoc = querySnapshot.docs[0];
      dispatch(storeCompanyData(companyDoc.data()));
    } else {
      dispatch(storeCompanyData(doc.data()));
    }
  });


    if(type === "sigin"){
     
      notifySuccessFxn("Logged In😊");
      setTimeout(()=>{ 
      navigate('/dashboard/home', { replace: true });
    }
      ,1000)
    }
  } else {
     
      notifyErrorFxn("Unauthorized❌")
      console.log("No such document!");
  }
}).catch((error) => {
  console.log("Error getting document:", error);
});
return user;
};

export const fetchCompanyData = () => async (dispatch, getState) => {
  const { user } = getState().auth || {};
  if (!user) {
    return;
  }

  const companyID = user.companyID || user.companyId;

  try {
    if (companyID) {
      const snapshot = await db
        .collection('companies')
        .where('companyID', '==', companyID)
        .limit(1)
        .get();

      if (!snapshot.empty) {
        dispatch(storeCompanyData(snapshot.docs[0].data()));
        return;
      }
    }

    if (user.uid) {
      const companyDoc = await db.collection('companies').doc(user.uid).get();
      if (companyDoc.exists) {
        dispatch(storeCompanyData(companyDoc.data()));
      }
    }
  } catch (error) {
    console.log('Error fetching company data:', error);
  }
};


export const getUserProfilePic = (idArray) => async (dispatch) => {
  //var user = db.collection("users").doc(id);
   console.log("idArray at this given moment is:",idArray)
const watchListItem =  db.collection('users').where('uid', 'in', idArray);
  
  watchListItem.get().then((snapshot) => {
    const imageLinks = snapshot.docs.map((doc) => (doc.data().profileImage));
    const identifier = snapshot.docs.map((doc) => (doc.data().uid));
    const profileImages = []
    
  //push the profile image where the document in watching matches the id in idArray
    idArray.forEach((item)=>{
      
      profileImages.push(imageLinks[identifier.indexOf(item)])

    })


 
    if (profileImages.length){
     console.log(" 145 auth action- the submitted images array is",profileImages)
  dispatch(storeProfileImages(profileImages));  
 
      
  } else {
     
      //notifyErrorFxn("Unauthorized❌")
      console.log("No users imagse!");
  }
 }
 
  ) 
  .catch((error) => {
  console.log("Error getting document:", error);
});

};


export const uploadProfileImage = (profileData, file, userID, navigate, setLoading) => async (dispatch) => {
  const imageName = uuidv4() + '.' + file?.name?.split('.')?.pop();
  console.log('File Name: ', imageName);
  const uploadTask = storage.ref(`profile_images/${imageName}`).put(file);
  uploadTask.on(
    "state_changed",
    snapshot => {
      const progress = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      // setProgress(progress);
    },
    error => {
      console.log(error);
    },
    () => {
      storage
        .ref("profile_images")
        .child(imageName)
        .getDownloadURL()
        .then(url => {
          console.log('Image URL: ', url);
          dispatch(updateProfile(profileData, userID, file, navigate, setLoading, url));
        });
    }
  );
}


export const updateProfile = (profileData, userID, file, navigate, setLoading, url) => async (dispatch) => {
  // return  
  db.collection('users').doc(userID).update({
    paymentLink: profileData.paymentLink,
    imageUrl: url,
  }).then((res)=>{
       if(profileData?.password){
        //update password start
        const user = auth.currentUser;
        user.updatePassword(profileData.password)
          .then(() => {
            setLoading(false);
            console.log("Password updated successfully");
            notifySuccessFxn("Updated successfully");
            navigate('/dashboard/home', { replace: true });
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error updating password: ", error);
            notifyErrorFxn(error.message);
          });
       //update password end
       }else{
        setLoading(false);
        console.error("No Password to update");
        notifySuccessFxn("Updated successfully");
        navigate('/dashboard/home', { replace: true });
       }
     
  }).catch((err) => {
    setLoading(false);
    console.log("ERR-: ", err);
  })
}


export const logout = (navigate) => async (dispatch) => {
  fb.auth().signOut().then(() => {
    dispatch(logoutFxn());
    dispatch(clearUser());
    dispatch(clearGroup());
    navigate('/login', { replace: true });
    console.log('logout successful!');
  }).catch((error) => {
    // An error happened.
    console.log('logout failed response: ', error.message);
  });
  
}